import {Box, Button, Divider, Flex, Image, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {colors} from 'theme';
import {TranslationKeys} from 'translations';
import {IOrder} from 'types';

interface Props {
  order: IOrder;
  t: (term: TranslationKeys) => string;
}

export const Order: FC<Props> = ({order, t}) => {
  const {provider_logo, provider_name, uuid, money, status, is_canceled} = order;

  const getOrderConfig = () => {
    return {
      status: status.name ?? `${t('ORDER_STATUS_HERE')}...`,
      color: is_canceled ? colors.red : colors.green,
      buttonText: t('DETAILS'),
    };
  };

  const orderConfig = getOrderConfig();

  const goToOrder = () => {
    window.location.href = `/order/${uuid}`;
  };

  return (
    <Box w="full" my="3px" borderRadius="16px" p="15px" border="1px solid #E6E6E6">
      <Flex>
        <Image borderRadius="16px" width={['65px', '65px']} alignSelf="flex-start" src={provider_logo} alt="img" />
        <Box ml="15px" w="full">
          <Text as="h3" fontSize="18px" fontWeight="bold">
            {provider_name}
          </Text>
          <Text as="h4" fontSize="16px" color={orderConfig.color}>
            {orderConfig.status}
          </Text>
          <Divider color={colors.borderGray} my="15px" />
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontWeight="600" fontSize="16px">
              {money.order_total} {t('CURRENCY')}
            </Text>
            <Button as="a" variant="gray" h="45px" fontWeight="500" onClick={goToOrder}>
              {orderConfig.buttonText}
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};
